export enum Currencies {
    USD = 'USD',
    HKD = 'HKD',
    GBP = 'GBP',
    CAD = 'CAD'
}
